import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Vacancy from './Vacancy';
import { clearfix, toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import { inject, observer } from 'mobx-react';
import mq from '@/utils/media-queries';

const Styled = styled.div``;

const Group = styled.div`
  padding-bottom: ${toVw(133)};
  margin-bottom: ${toVw(142)};
  border-bottom: 1px solid #1b1b1b;
  ${clearfix};

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }

  ${mq.tablet(css`
    padding-bottom: ${toVwTablet(92)};
    margin-bottom: ${toVwTablet(141)};
  `)};

  ${mq.mobile(css`
    padding-bottom: ${toVwMobile(80)};
    margin-bottom: ${toVwMobile(80)};
  `)};
`;

const GroupName = styled.div`
  width: ${toVw(288)};
  padding-right: ${toVw(30)};
  box-sizing: border-box;
  color: ${props => props.theme.colorMinor};
  float: left;

  ${mq.tablet(css`
    width: auto;
  `)};

  ${mq.mobile(css`
    float: none;
    margin-bottom: ${toVwMobile(40)};
  `)};
`;

const GroupItems = styled.div`
  float: left;
  width: ${toVw(500)};
  box-sizing: border-box;

  ${mq.tablet(css`
    float: right;
    width: ${toVwTablet(456)};
    padding-right: ${toVwTablet(25)};
  `)};

  ${mq.mobile(css`
    float: none;
    width: 100%;
    padding-right: 0;
  `)};
`;

const StyledVacancy = styled(Vacancy)`
  margin-bottom: ${toVw(95)};

  &:last-child {
    margin-bottom: 0;
  }

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(80)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(95)};
  `)};
`;

class Vacancies extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
  };

  render() {
    const { items } = this.props;

    return (
      <Styled>
        {items.map((group, index) => (
          <Group key={index}>
            <GroupName>{group.name}</GroupName>
            <GroupItems>
              {group.items.map(item => (
                <StyledVacancy key={item.id} {...item} />
              ))}
            </GroupItems>
          </Group>
        ))}
      </Styled>
    );
  }
}

export default Vacancies;



// WEBPACK FOOTER //
// ./src/scenes/Jobs/components/Vacancies.js